module.exports = "<div class=\"shelfBundleTile tile\">\r\n    <div class=\"shelfBundleTile-title\" ng-bind-html=\"::$ctrl.bundle.Name | sanitize\"></div>\r\n\r\n    <ul class=\"shelfBundleTile-list\">\r\n        <li class=\"shelfBundleTile-item\" ng-repeat=\"product in ::$ctrl.bundle.Products | orderBy:'UnitWeightInGrams' track by product.Stockcode\">\r\n            <wow-shelf-product-variant total-variants=\"::$ctrl.bundle.Products.length\" product=\"::product\"></wow-shelf-product-variant>\r\n        </li>\r\n    </ul>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/shelfproduct/shelf-bundle-tile.component.html
// module id = 235
// module chunks = 0 2